import { render, staticRenderFns } from "./PlanPagosDetails.vue?vue&type=template&id=4f1a2bbd"
import script from "./PlanPagosDetails.vue?vue&type=script&lang=js"
export * from "./PlanPagosDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports